module.exports = __webpack_public_path__ + "static/2-1849a9529e8414c64a4a8a73af318151.png";